import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteConfirmationPopupComponent } from '../../../widgets/components/delete-confirmation-popup/delete-confirmation-popup.component';
import { displayModalComponent } from '../../../widgets/models/utils/general';
import { ISavedSearch, SearchService } from '../../services/search.service';
import { SaveConfirmationPopupComponent } from '../preferences-confirmation-popup/save-confirmation-popup.component';
import { SearchSavePopupComponent } from '../search-save-popup/SearchSavePopupComponent';
import { CommonModule, NgIf } from '@angular/common';


@Component({
  selector: 'app-search-saved',
  standalone: true,
  imports: [SaveConfirmationPopupComponent, NgIf, CommonModule],
  templateUrl: './search-saved.component.html',
  styleUrls: ['./search-saved.component.scss']
})
export class SearchSavedComponent implements OnInit {
  @Output() runSavedQuery = new EventEmitter<ISavedSearch>();

  queryName: string = "";

  @ViewChild('savesearch') public savesearch?: TemplateRef<any>;

  savedQueries: ISavedSearch[] = [];

  constructor(private srchSvc: SearchService, private modalService: NgbModal) { }

  ngOnInit(): void {
  }


  public saveCurrentSearch() {
    // Need to ask for displayname first.
    this.showSaveDialog()

    //this.srchSvc.saveCurrentSearch();
  }

  private showSaveDialog() {
    const modalref = displayModalComponent(SearchSavePopupComponent, 's', { title: "Save Query", showSave: true, showCancel: true, showCross: true, scrollable: false }, this.modalService, []).result.then(
      (result) => {
        

      },
      (reason) => {
        // Cancel
      });
  }

  runSavedSearch(id: string) {
    const query = this.savedQueries.find(qry => qry.id == id);
    if (query != undefined) {
      this.runSavedQuery.emit(query);
    }
  }

  deleteSaved(id: string) {
    let params: any[] = [];
    params.push({ 'usedFor': 'SearchDelete' });
    const modalref = displayModalComponent(DeleteConfirmationPopupComponent, 's', { title: "Delete Query", showSave: false, showCancel: false, showYes: true, showNo: true, showCross: false, scrollable: false }, this.modalService, params).result.then(
      (result) => {
      },
      (reason) => {
        // Cancel
      });
  }
}
